/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  POST: 'CREATE_VIDEO_CONTENT_SIDE_PANELS',
  PUT: 'UPDATE_VIDEO_CONTENT_SIDE_PANELS',
  DELETE: 'DELETE_VIDEO_CONTENT_SIDE_PANELS',
  RESET: 'RESET_VIDEO_CONTENT_SIDE_PANELS',
  ADD_VIDEO: 'ADD_VIDEO_IN_VIDEO_CONTENT_SIDE_PANELS',
  RELOAD: 'RELOAD_VIDEO_CONTENT_SIDE_PANELS',
};

export const getDraftId = () => (`videoContentSidePanels-draft${new Date().valueOf()}`);

export const videoContentSidePanelsReducer = (state = [], action) => {
  switch (action.type) {
    case types.POST:
      const id = action.payload.id ? action.payload.id : getDraftId();
      return [
        ...state,
        { ...action.payload, id },
      ];
    case types.PUT:
      return state.map((child) => (child.id == action.payload.id ? action.payload : child));
    case types.DELETE:
      const newValues = [...state];
      const index = newValues.indexOf(action.item);
      newValues.splice(index, 1);
      return newValues;
    case types.ADD_VIDEO:
      const newState = [...state];
      const valueIndex = newState.findIndex((item) => item.id === action.item.videoContentSidePanelId);
      const valueToUpdate = { ...newState[valueIndex] };

      valueToUpdate.video = action.item;
      valueToUpdate.videoContentVideoId = action.item.id;
      newState[valueIndex] = valueToUpdate;

      return newState;
    case types.RELOAD:
      return action.payload;
    case types.RESET:
      return [];
    default:
      return state;
  }
};
